import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';

import useAddPage from 'hooks/useAddPage';
const ItemtypesAddPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		itemtype: yup.string().required().label("Item Name/Type"),
		description: yup.string().required().label("Description"),
		category: yup.string().required().label("Category"),
		baseprice: yup.number().required().label("Base Price"),
		maxquantityperbooking: yup.number().required().label("Max quantity per booking"),
		weightrange: yup.string().required().label("Weight Range"),
		userid: yup.number().nullable().label("Userid"),
		partnerid: yup.string().required().label("Partnerid")
	});
	
	//form default values
	const formDefaultValues = {
		itemtype: '', 
		description: '', 
		category: '', 
		baseprice: '', 
		maxquantityperbooking: "50", 
		weightrange: "2", 
		userid: auth.userId, 
		partnerid: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/itemtypes`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="ItemtypesAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Add New Itemtype"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container-fluid">
            <div className="grid ">
                <div className="col comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Item Name/Type *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="itemtype"  onChange={formik.handleChange}  value={formik.values.itemtype}   label="Item Name/Type" type="text" placeholder="Enter Item Name/Type"        className={inputClassName(formik?.errors?.itemtype)} />
                                                <ErrorMessage name="itemtype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Description *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="description"  onChange={formik.handleChange}  value={formik.values.description}   label="Description" type="text" placeholder="Enter Description"        className={inputClassName(formik?.errors?.description)} />
                                                <ErrorMessage name="description" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Category *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/category_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="category"     optionLabel="label" optionValue="value" value={formik.values.category} onChange={formik.handleChange} options={response} label="Category"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.category)}   />
                                                    <ErrorMessage name="category" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Base Price *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="baseprice"  onChange={formik.handleChange}  value={formik.values.baseprice}   label="Base Price" type="number" placeholder="Enter Base Price"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.baseprice)} />
                                                <ErrorMessage name="baseprice" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Max quantity per booking *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="maxquantityperbooking"  onChange={formik.handleChange}  value={formik.values.maxquantityperbooking}   label="Max quantity per booking" type="number" placeholder="Enter Max quantity per booking"  min={0}  step="any"    className={inputClassName(formik?.errors?.maxquantityperbooking)} />
                                                <ErrorMessage name="maxquantityperbooking" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Weight Range *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="weightrange"  onChange={formik.handleChange}  value={formik.values.weightrange}   label="Weight Range" type="text" placeholder="Enter Weight Range"        className={inputClassName(formik?.errors?.weightrange)} />
                                                <ErrorMessage name="weightrange" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Userid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="userid"  onChange={formik.handleChange}  value={formik.values.userid}   label="Userid" type="number" placeholder="Enter Userid"  min={0}  step="any" disabled   className={inputClassName(formik?.errors?.userid)} />
                                                <ErrorMessage name="userid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Partnerid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource onLoad={(res) => formik.setFieldValue('partnerid', '')} loadOnMount={false} apiPath={`components_data/partnerid_option_list_2?lookup_userid=${formik.values.userid}`}  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="partnerid"     optionLabel="label" optionValue="value" value={formik.values.partnerid} onChange={formik.handleChange} options={response} label="Partnerid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.partnerid)}   />
                                                    <ErrorMessage name="partnerid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Submit" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
ItemtypesAddPage.defaultProps = {
	primaryKey: 'itemid',
	pageName: 'itemtypes',
	apiPath: 'itemtypes/add',
	routeName: 'itemtypesadd',
	submitButtonLabel: "Submit",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Create Record",
	msgAfterSave: "Record added successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default ItemtypesAddPage;
